module.exports = __webpack_public_path__ + "img/20180815_150609_093.3d8eeda8.jpg";